import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import React from 'react';
import Link from '@mui/material/Link';

const useStyles = makeStyles()(theme => ({
  areabg: {
    background: theme.palette.background.light,
  },
}));

const CommentHeader = ({ comment }) => {
  const {
    depth,
    rootTitle,
    rootAuthor,
    rootPermlink,
    parentAuthor,
    parentPermlink,
  } = comment;

  const { classes } = useStyles();

  return (
    <>
      <div
        className={`border p-3 mb-2 
      ${classes.areabg}`}
      >
        <Link color="textPrimary" href={`/@${rootAuthor}/${rootPermlink}`}>
          <Typography gutterBottom variant="h6" component="h4">
            {`Re: ${rootTitle || ''}`}
          </Typography>
        </Link>
        <div>
          <Link color="textPrimary" href={`/@${rootAuthor}/${rootPermlink}`}>
            <strong className="ablue hoverline">Go to original post</strong>
          </Link>
        </div>
        {depth > 1 && (
          <div>
            <Link
              color="textPrimary"
              href={`/@${parentAuthor}/comments/${parentPermlink}`}
            >
              <strong className="ablue hoverline">Go to parent comment</strong>
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default CommentHeader;
